import React, { useState, useEffect, useContext } from "react"
import styles from "./Calendar.module.css"
import { Button } from "@mui/material";
import { ReservationType } from "../page/Reservation/Reservation";
import { AuthContext, AuthContextType } from "../Auth"
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { productData } from "../page/Constant/ConstantRegister";
import { baseUrl } from "../url";
import { useNavigate } from "react-router-dom";

export type PushReservation = {
    office:string;
    productname: string;
    color: string;
    left_right: string;
    size: string;
    quantity: number;
    reservation_date: string | null;
    username: string;
}

export default function Calendar() {

    const [schedule, setSchedule] = useState<ReservationType[]>([]);
    const [selectedDate, setSelectedDate] = useState<DateObj | null>(null);
    const [selectManufacture, setSelectManufacture] = useState<string[]>([]);
    const [selectedManufacture, setSelectedManufacture] = useState<string>("");
    const [products, setProducts] = useState<productData[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<string>("");
    const [selectLR, setSelectLR] = useState<string[]>([]);
    const [selectSize, setSelectSize] = useState<string[]>([]);
    const [selectColor, setSelectColor] = useState<string[]>([]);
    const [selectedLR, setSelectedLR] = useState<string>("");
    const [selectedSize, setSelectedSize] = useState<string>("");
    const [selectedColor, setSelectedColor] = useState<string>("");
    const [inputedQuantity, setInputedQuantity] = useState<string>("1");
    const { auth,setAuth } = useContext(AuthContext) as AuthContextType;
    const [reload, setReload] = useState<boolean>(false);
    const [toggles, setToggles] = useState<boolean[]>([]);
    const [selectedOffice, setSelectedOffice] = useState<string>(auth.office||"");
     const [selectUser, setSelectUser] = useState<string[]>([]);
    const [selectedUser, setSelectedUser] = useState<string>(auth.authority==="user"?auth.username?auth.username:"":""); 

    const navigate = useNavigate();

    const day: string[] = [
        " sun", " mon", " tue", " wed", " thu", " fri", " sat"
    ]

    useEffect(() => {
        const fetchSelectInit = async () => {
            const response = await fetch(`${baseUrl}/getmanufacture`,{
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            return 
        }
            const Manufactures = data.manufacture.map((item: Object) => Object.values(item))
            setSelectManufacture(Manufactures);
        }
        fetchSelectInit();
    }, [])

    useEffect(() => {
        const fecthSchedule = async () => {
            const response = await fetch(`${baseUrl}/getreservation`,{
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ office: selectedOffice })
            })
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            let newData = [...data];
            for (let i = 0; i < data.length; i++) {
                let reservationDate = new Date(data[i].reservation_date);
                reservationDate.setHours(reservationDate.getHours() + 9);
                if (newData[i].prepared === 0) { newData[i].prepared = false };
                if (newData[i].prepared === 1) { newData[i].prepared = true };
                newData[i].reservation_date = {
                    year: reservationDate.getFullYear(),
                    month: reservationDate.getMonth() + 1,
                    date: reservationDate.getDate()
                }
            }
            setSchedule(newData);   
            const toggleArray = new Array(data.length).fill(false);
            setToggles(toggleArray);
        }
        fecthSchedule();
    }, [reload,selectedOffice, navigate, setAuth])

    useEffect(() => {
            const fetchSelectUser = async () => {
                const response = await fetch(`${baseUrl}/getUser`,{
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ office: selectedOffice })
                });
                const data = await response.json();
                if(data.isAuth===false){
                return 
            }
            let users = data.map((item:Object )=> Object.values(item)[0]);
            console.log(users);
            setSelectUser(users);
            setSelectedUser(users[0]);
            }
            fetchSelectUser();
        }
        , [ selectedOffice ])
    
    useEffect(() => {
        const fetchProduct = async () => {
            const response = await fetch(`${baseUrl}/getproducts`, {
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "manufacture": selectedManufacture
                })
            });
            const data = await response.json();
            if(data.isAuth===false){
            return
        }
            setProducts(data);
        }
        fetchProduct();
    }, [selectedManufacture, navigate, setAuth])

    useEffect(() => {
        const fetchProductdata = async () => {
            if (selectedProduct === "") {
                setSelectLR([]);
                setSelectSize([]);
                setSelectColor([]);
                return
            }
            const selectedProductData = products.find(item=>item.productname===selectedProduct)
            const product_id = selectedProductData?.product_id;
            const response = await fetch(`${baseUrl}/productdata`, {
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "product_id": product_id })
            })
            const data = await response.json();
            if(data.isAuth===false){
            return 
        }
            setSelectLR(data.leftright);
            setSelectSize(data.size);
            setSelectColor(data.color);
            if (data.leftright.length > 0) {
                setSelectedLR(data.leftright[0]);
            }
            if (data.size.length > 0) {
                setSelectedSize(data.size[0]);
            }
            if (data.color.length > 0) {
                setSelectedColor(data.color[0]);
            }
        }
        fetchProductdata();

    }, [selectedProduct,products, navigate, setAuth])

    const today = new Date();
    const date = today.getDate();
    const month = today.getMonth();
    const year = today.getFullYear();
    const dayOfWeek = today.getDay();

    type DateObj = {
        date: number;
        month: number;
        year: number;
    }
    const days: DateObj[] = [];

    for (let i = 0; i < 5 * 7; i++) {
        const day: DateObj = {
            date: new Date(year, month, date - dayOfWeek + i).getDate(),
            month: new Date(year, month, date - dayOfWeek + i).getMonth(),
            year: new Date(year, month, date - dayOfWeek + i).getFullYear(),
        }
        days.push(day);
    }
    const dayMatrix: DateObj[][] = [];
    for (let i = 0; i < 5; i++) {
        const week = days.splice(0, 7);
        dayMatrix.push(week);
    }

    const handleDate = (date: DateObj) => {
        if (new Date(date.year, date.month, date.date) < new Date() || (new Date(date.year, date.month, date.date).getDay() === 0) || (new Date(date.year, date.month, date.date).getDay() === 6)) {
            return;
        }
        setSelectedDate(date);
    }

    const handleBack = () => {
        setSelectedDate(null);
        setSelectedManufacture("");
        setSelectedProduct("");
    }

    const handleManufacture = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedManufacture(e.target.value);
    }

    const handleProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedProduct(e.target.value);
    }

    const handleLR = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedLR(e.target.value);
    }

    const handleSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedSize(e.target.value);
    }
    const handleColor = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedColor(e.target.value);
    }

    const handleQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputedQuantity(e.target.value);
    }

    const pushReservation = async () => {
        if(auth.authority==="admin"){
            if(!selectedUser)
                return alert("使用者を選択してください。");
        }
        if (!selectedDate || !auth.username) {
            return
        }
        if (!selectedProduct) {
            return alert("製品を選択してください。");
        }
        if (Number(inputedQuantity) < 1) {
            return alert("数量が0以下になっています。");
        }
        const newReservation: PushReservation = {
            office:selectedOffice,
            username: (auth.authority==="user") ?auth.username:selectedUser,
            productname: selectedProduct,
            color: selectedColor,
            left_right: selectedLR,
            size: selectedSize,
            quantity: Number(inputedQuantity),
            reservation_date: `${selectedDate.year}-${selectedDate.month + 1}-${selectedDate.date}`,
        }
        const response = await fetch(`${baseUrl}/pushreservation`, {
            method: "POST",
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newReservation)
        });
        const data = await response.json();
        if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined , authority:"user"});
            return navigate("/login");}
        if (data.result) {
            setSelectedDate(null);
            setSelectedProduct("");
            setSelectedManufacture("");
            setInputedQuantity("1");
            setReload(!reload);
        }
    }

    // const handlePrepared = async (e: React.MouseEvent<HTMLButtonElement>, reservation_id: number) => {
    //     try {
    //         e.stopPropagation();
    //         const response = await fetch(`${baseUrl}/prepared`, {
    //             method: "POST",
    //             credentials: "include",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ reservation_id: reservation_id })
    //         })
    //         const data = await response.json();
    //         if(data.isAuth===false){
    //         alert("セッションが切れました。再度ログインしてください");
    //         setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
    //         return navigate("/login");}
    //         if (data.result) {
    //             setReload(!reload);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    // const handleNotPrepared = async (e: React.MouseEvent<HTMLButtonElement>, reservation_id: number) => {
    //     try {
    //         e.stopPropagation();
    //         const response = await fetch(`${baseUrl}/notprepared`, {
    //             method: "POST",
    //             credentials: "include",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ reservation_id: reservation_id })
    //         })
    //         const data = await response.json();
    //         if(data.isAuth===false){
    //         alert("セッションが切れました。再度ログインしてください");
    //         setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
    //         return navigate("/login");}
    //         if (data.result) {
    //             setReload(!reload);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    const handleLeave =async(e:React.MouseEvent<HTMLButtonElement>,index:number)=>{
        try{
            const item = schedule[index];
            const response = await fetch(`${baseUrl}/leave_reservation`,{
                method:"POST",
                credentials:"include",
                headers:{'Content-Type':'application/json'},
                body:JSON.stringify({
                    reservation_id:item.reservation_id,
                    office:item.office,
                    productname:item.productname,
                    color:item.color,
                    left_right:item.left_right,
                    size:item.size,
                    quantity:item.quantity
                })
                })
            const data= await response.json();
            if(response.status===403){
                alert(data.message);
                return;
            }
            console.log(data);
        }catch(error){
            console.error(error);
        }
    }

    const handleDelete = async (e: React.MouseEvent<HTMLButtonElement>, reservation_id: number) => {
        try {
            e.stopPropagation();
            const response = await fetch(`${baseUrl}/delete_reservation`, {
                method: "DELETE",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ reservation_id: reservation_id })
            })
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            if (data.result) {
                setReload(!reload);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleToggle = (e:React.MouseEvent,index2: number) => {
        e.stopPropagation();
        const newToggles = [...toggles];
        newToggles[index2] = !newToggles[index2];
        setToggles(newToggles);
    }


    return (
        <div className={styles.div}>
            <label htmlFor="支店" className={styles.label}>支店：
                <select id="支店" value={selectedOffice} className={styles.select} onChange={(e)=>setSelectedOffice(e.target.value)}>
                    <option value="函館店">函館店</option>
                    <option value="札幌店">札幌店</option>
                    <option value="釧路店">釧路店</option>
                    <option value="室蘭店">室蘭店</option>
                </select>
            </label>
            {selectedDate ? <div className={styles.back} onClick={() => handleBack()}></div> : null}
            <div className={styles.calendarHeader}>{day.map((item,index)=><div className={styles.dayHead} key={index}>{item}</div>)}</div>
            <div className={styles.calendar}>{dayMatrix.map((item, index) =>
                <div key={index} className={styles.dayMatrix}>
                    {item.map((item2, index2) =>
                    <div key={index2} onClick={() => handleDate(item2)} className={(index2 < dayOfWeek && index === 0) ? styles.below : (index2 === dayOfWeek && index === 0) ? styles.today : (index2 === 0) ? styles.td1 : (index2 === 6) ? styles.td2 : styles.td}>
                        <div>{(item2.date === 1 && item2.month === 0) ? `${item2.year}/${item2.month + 1}/${item2.date}` : (item2.date === 1) ? `${item2.month + 1}/${item2.date}` : `${item2.date}`}
                        </div>
                        {schedule ?
                            schedule.map((item3, index3) =>
                                (item3.reservation_date && item3.reservation_date.year === item2.year) && (item3.reservation_date.month === item2.month+1) && (item3.reservation_date.date === item2.date) &&
                            <div key={index3} onClick={(e)=>handleToggle(e,index3)}> {item3.prepared?<div key={index3} ><CheckIcon sx={{ color : "blue" }}/></div>:<div><PriorityHighIcon sx={{ color: "red" }}/></div>}</div>)
                                : null }
                        {schedule ?
                            schedule.map((item3, index3) =>
                                <div key={index3}>
                                    {(toggles[index3] && (item3.reservation_date &&item3.reservation_date.year===item2.year )&& (item3.reservation_date.month===item2.month+1)&& (item3.reservation_date.date===item2.date))&& <div className={styles.overlay } onClick={(e) => handleToggle(e,index3)}></div>}
                                    {(toggles[index3] && (item3.reservation_date &&item3.reservation_date.year===item2.year)&& (item3.reservation_date.month===item2.month+1)&& (item3.reservation_date.date===item2.date))&& <div className={styles.tooltip} onClick={(e) => e.stopPropagation()}>
                                        <p className={styles.p}>製品名:{item3.productname}</p>
                                        <p className={styles.p}> 色:{item3.color}</p>
                                        <p className={styles.p}>左右:{item3.left_right}</p>
                                        <p className={styles.p}>サイズ:{item3.size}</p>
                                        <p className={styles.p}>数量:{item3.quantity}</p>
                                        <p className={styles.p}>予約者:{item3.username}</p>
                                        <p className={styles.p}>予約日:{item3.reservation_date.year}/{item3.reservation_date.month}/{item3.reservation_date.date}</p>
                                        <div className={styles.buttonWrapper}>
                                            {/* {!item3.prepared ? <Button size="small" sx={{ margin: 0 }} onClick={(e) => handlePrepared(e, item3.reservation_id)}>準備済みにする</Button> :
                                                <Button size="small" sx={{ margin: 0 }} onClick={(e) => handleNotPrepared(e, item3.reservation_id)}>未準備に戻す</Button>} */}
                                            <Button size="small" sx={{ margin: 0 }} onClick={(e) => handleLeave(e, index3)}>出庫</Button>
                                            <Button size="small" sx={{ margin: 0 }} onClick={(e) => handleDelete(e, item3.reservation_id)}>削除</Button>
                                        </div>
                                    </div>}
                                </div>
                            )
                            : null}
                        {selectedDate ? (selectedDate.date === item2.date && selectedDate.month === item2.month) &&
                            <div className={styles.window}>
                                <h4 className={styles.h4}>{selectedDate.year}/{selectedDate.month + 1}/{selectedDate.date}の出庫予約</h4>
                                {(auth.authority === "admin")?
                                <label htmlFor="使用者" className={styles.label}>使用者：
                                <select value={selectedUser} id="使用者" onChange={(e)=>setSelectedUser(e.target.value)}>
                                {selectUser.map(item=><option key={item} value={item}>{item}</option>)}
                                </select>
                                </label>:null
                                }
                                <label htmlFor="メーカー" className={styles.label}>メーカー
                                    <select value={selectedManufacture} id="メーカー" onChange={handleManufacture} className={styles.select}>
                                        <option value="">未設定</option>
                                        {selectManufacture.map(item => (<option key={item} value={item}>{item}</option>))}
                                    </select>
                                </label>
                                <label htmlFor="製品" className={styles.label}>製品
                                    <select value={selectedProduct} id="製品" onChange={handleProduct} className={styles.select}>
                                        <option value="">未設定</option>
                                        {products.map(item => (<option key={item.productname} value={item.productname}>{item.productname}</option>))}
                                    </select>
                                </label>
                                <label htmlFor="左右" className={styles.label}>左右
                                    <select value={selectedLR} id="左右" onChange={handleLR} className={styles.select}>
                                        {selectLR.map(item => (<option key={item} value={item}>{item}</option>))}
                                    </select>
                                </label>
                                <label htmlFor="サイズ" className={styles.label}>サイズ
                                    <select value={selectedSize} id="サイズ" onChange={handleSize} className={styles.select}>
                                        {selectSize.map(item => (<option key={item} value={item}>{item}</option>))}
                                    </select>
                                </label>
                                <label htmlFor="色" className={styles.label}>色
                                    <select value={selectedColor} id="色" onChange={handleColor} className={styles.select}>
                                        {selectColor.map(item => (<option key={item} value={item}>{item}</option>))}
                                    </select>
                                </label>
                                <label htmlFor="数量" className={styles.label}>数量
                                    <input id="数量" type="number" onChange={handleQuantity} className={styles.input} value={inputedQuantity}/>
                                </label>
                                <Button variant="contained" sx={{ width: 10, margin: 1, alignSelf: "center" }} onClick={() => pushReservation()}>登録</Button>
                            </div> : null}</div>)}</div>)
            }</div>
        </div >
    )
}